<template>
  <div class="home-game bg-ui-panel grey100--text d-flex">
    <div class="game-card-layout d-flex">
      <SpinnersWheel
        class="wheel"
        size="100%"
        :conga="{}"
        :game="fakeGame"
      />

      <div class="align-self-end pa-4">
        <div class="game-info mb-1">
          <h3 class="text-uppercase grey100--text text-body-1 font-weight-bold">
            Spinner Battles
          </h3>
          <p class="text--secondary text-body-2">
            2-4 player PVP battles
          </p>
        </div>


        <h5 class="game-stats text-body-2 text--secondary d-flex align-center">
          {{ games }} games
          <span class="mx-2">&middot;</span>
          <scrap :amount="bet" class="text-caption text--secondary" />
        </h5>
      </div>
    </div>

    <div v-if="xpBonus > 1" class="xp-bonus px-2 py-2 font-weight-bold lh-1 text-caption green700 green200--text">
      +{{ (xpBonus - 1) * 100 | toLocale }}% XP
    </div>
  </div>
</template>

<script>
import SpinnersWheel from '@/views/games/Spinners/components/SpinnersWheel'


export default {
  components: {
    SpinnersWheel,
  },
  props: {
    stats: {
      type: Object,
      default: null,
    },
    conga: {
      type: Object,
      default: null,
    },
  },
  computed: {
    games() {
      return this.stats?.games ?? 0
    },
    bet() {
      return this.stats?.total ?? 0
    },
    xpBonus() {
      return this.conga?.games.spinners.xpMultiplier ?? 1
    },
    fakeGame() {
      return {
        slots: 4,
        players: {
          1: {
            color: 'red',
            amount: 1,
          },
          2: {
            color: 'green',
            amount: 1,
          },
          3: {
            color: 'blue',
            amount: 1,
          },
          4: {
            color: 'yellow',
            amount: 1,
          },
        },
        data: {
          creator: 1,
        },
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.home-game {
  position: relative;
  height: 180px;
  cursor: pointer;
  transition: transform 0.3s ease;

  .game-card-layout {
    overflow: hidden;

    @include overlay;
  }

  .wheel {
    position: absolute;
    z-index: 1;
    top: 0;
    right: 0;
    width: 60%;
    transition: transform 0.8s ease, opacity 0.3s ease;
    transform: translate(10%, -30%) rotate(15deg);

    ::v-deep .arrow {
      display: none;
    }
  }

  .game-info,
  .game-stats {
    position: relative;
    z-index: 2;
    transition: transform 0.6s ease;
  }

  .game-info {
    text-shadow: 0 0 5px black;
  }

  .xp-bonus {
    position: absolute;
    z-index: 3;
    top: 0;
    right: 0;
    background: gold;
    transform: translate(20%, -50%) rotate(-3deg);
  }

  &:hover {
    transform: translateY(-3px);

    .wheel {
      transform: translate(0%, -20%) rotate(270deg);
    }

    .game-info {
      transform: translate(16px, -20%) rotate(2deg) scale(1.1);
    }

    .game-stats {
      transform: translate(16px, -10%) rotate(2deg) scale(1.1);
    }
  }
}
</style>
